import APIClient from '@/shared/http/clients/api'

const resourceName = 'threec'
const APICore = process.env.APIBaseURLCore
/**
 * Repositório para configurações da 3C Plus
 */
class ThreeCPlusRepository {
  /**
   * Busca a configuração principal da 3C Plus
   * GET /api/v1/threec/configuration
   */
  async getConfig () {
    return APIClient.get(`${APICore}/${resourceName}/configuration`)
  }

  /**
   * Atualiza a configuração principal da 3C Plus
   * PUT /api/v1/threec/configuration
   */
  async updateConfig (configData) {
    return APIClient.put(`${APICore}/${resourceName}/configuration`, configData)
  }

  /**
   * Busca todos os usuários vinculados à 3C Plus
   * GET /api/v1/threec/users
   */
  async getUsers (params = {}) {
    const queryParams = new URLSearchParams()

    if (params.page !== undefined) queryParams.append('page', params.page)
    if (params.size !== undefined) queryParams.append('size', params.size)
    if (params.enabled !== undefined) queryParams.append('enabled', params.enabled)
    if (params.threecUsername) queryParams.append('threecUsername', params.threecUsername)
    if (params.systemUserName) queryParams.append('systemUserName', params.systemUserName)

    const queryString = queryParams.toString()
    const url = queryString ? `${APICore}/${resourceName}/users?${queryString}` : `${APICore}/${resourceName}/users`

    return APIClient.get(url)
  }

  /**
   * Busca um usuário específico por ID
   * GET /api/v1/threec/users/{id}
   */
  async getUserById (userId) {
    return APIClient.get(`${APICore}/${resourceName}/users/${userId}`)
  }

  /**
   * Busca um usuário da 3C Plus pelo ID do usuário do sistema
   * GET /api/v1/threec/users?systemUserId={systemUserId}
   */
  async getUserBySystemUserId (systemUserId) {
    return APIClient.get(`${APICore}/${resourceName}/users?systemUserId=${systemUserId}`)
  }

  /**
   * Busca as credenciais 3C Plus do usuário logado
   * GET /api/v1/threec/users/current-user
   */
  async getCurrentUserCredentials () {
    return APIClient.get(`${APICore}/${resourceName}/users/current-user`)
  }

  /**
   * Cria um novo usuário vinculado à 3C Plus
   * POST /api/v1/threec/users
   */
  async createUser (userData) {
    return APIClient.post(`${APICore}/${resourceName}/users`, userData)
  }

  /**
   * Atualiza um usuário vinculado à 3C Plus
   * PUT /api/v1/threec/users/{id}
   */
  async updateUser (userId, userData) {
    return APIClient.put(`${APICore}/${resourceName}/users/${userId}`, userData)
  }

  /**
   * Exclui um usuário vinculado à 3C Plus
   * DELETE /api/v1/threec/users/{id}
   */
  async deleteUser (userId) {
    return APIClient.delete(`${APICore}/${resourceName}/users/${userId}`)
  }

  /**
   * Busca usuários do sistema para seleção
   * GET /api/v1/usuarios/?inative=0&sort=username,asc&size=500
   */
  async getSystemUsers () {
    return APIClient.get(`${APICore}/usuarios/?inative=0&sort=username,asc&size=500`)
  }
}

export default new ThreeCPlusRepository()



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/threeCPlus.js